import { constants as config } from '@config';

module.exports = function (S) {
  const svgroot = S.svgroot;
  const getNextId = S.getNextId;
  const getElem = S.getElem;
  const addSvgElementFromJson = S.addSvgElementFromJson;
  const selectorManager = S.selectorManager;
  const canvas = S.canvas;
  const curConfig = S.curConfig;

  const NS = svgedit.NS;
  const RESIZE_BACKGROUND_ZOOM = 0.7;
  let previousZoom;
  let isEnabled = true;

  function showBackgroundClipper (background, callback) {
    $('#svgroot').addClass('background-image-cropping');
    canvas.clearSelection();
    $('#selectorGrip_rotateconnector').hide();
    $('#selectorGrip_rotate').hide();

    const layoutBox = canvas.copyElem(background);
    const clipPathElem = canvas.addSvgElementFromJson({
      element: 'rect',
      curStyles: false,
      attr: {
        x: 0,
        y: 0,
        width: canvas.contentW,
        height: canvas.contentH,
        opacity: 0.5,
        fill: '#000',
        class: 'layoutClipper'
      }
    });

    canvas.createLayer('clipperImage');
    const clipperImage = canvas.getCurrentDrawing().current_layer;
    clipperImage.setAttribute('class', 'clipperImage');
    layoutBox.setAttribute('id', canvas.getNextId());
    layoutBox.setAttribute('class', 'layoutClipperImage background');
    const bb = {
      x: 0,
      y: 0,
      width: canvas.contentW,
      height: canvas.contentH
    };

    layoutBox.textContent = (bb.x + ' ' + bb.y + ' ' + bb.width + ' ' + bb.height);
    clipperImage.appendChild(layoutBox);

    canvas.createLayer('clipperSelector');

    const clipperSelector = canvas.getCurrentDrawing().current_layer;
    clipperSelector.setAttribute('class', 'clipperSelector');
    clipperSelector.appendChild(clipPathElem);

    canvas.setCurrentLayer('clipperImage');

    previousZoom = canvas.getZoom();
    previousZoom > RESIZE_BACKGROUND_ZOOM && canvas.setZoom(RESIZE_BACKGROUND_ZOOM);

    $(layoutBox).on('dblclick', function (ev) {
      cropBackgroundContent(background, layoutBox, true, callback);
      ev.preventDefault();
      ev.stopPropagation();
    });

    canvas.addToSelection([layoutBox], true);

    canvas.call('editor.cropping', true);
    $('#svgcontent').css('overflow', 'visible').find('g.main, g.background').find('image').hide();
    $(clipperImage).removeAttr('clip-path');
  }

  function showBackgroundPopupMenu (background) {
    let backgroundElement = $(background).find('image')[0]
      ? $(background).find('image')
      : $(background).find('rect');

    if (!backgroundElement[0]) {
      backgroundElement = createTransparentBackground(background);
    }

    canvas.clearSelection();
    canvas.addToSelection(backgroundElement, false);
  }

  function createTransparentBackground (background) {
    const svgcontent = $('#svgcontent');
    if (!background) {
      background = document.createElementNS(NS.SVG, 'g');
      $(background).addClass('background');

      background.setAttribute('style', 'pointer-events:none');

      svgcontent.insertBefore(background, svgcontent.firstChild);
    }
    const elem = document.createElementNS(NS.SVG, 'rect');
    elem.setAttribute('id', config.background.color);
    elem.setAttribute('fill', 'none');
    elem.setAttribute('x', '0');
    elem.setAttribute('y', '0');
    elem.setAttribute('width', '100%');
    elem.setAttribute('height', '100%');
    $(background).prepend(elem);

    const title = document.createElementNS(NS.SVG, 'title');
    title.setAttribute('style', 'pointer-events:inherit');
    title.textContent = 'Background';
    $(background).append(title);

    return $(elem);
  }

  function cropBackgroundContent (background, layoutBox, hasChanges, callback) {
    $('#svgroot').removeClass('background-image-cropping');
    $('#svgcontent').css('overflow', 'hidden').find('image').show();
    if (hasChanges) {
      const coord = {
        x: layoutBox.getAttribute('x'),
        y: layoutBox.getAttribute('y'),
        width: layoutBox.getAttribute('width'),
        height: layoutBox.getAttribute('height')
      };

      canvas.clearSelection();

      $(background).get(0).setAttribute('x', coord.x);
      $(background).get(0).setAttribute('y', coord.y);
      $(background).get(0).setAttribute('width', coord.width);
      $(background).get(0).setAttribute('height', coord.height);
    }

    canvas.deleteCurrentLayer();
    canvas.deleteCurrentLayer();
    canvas.call('editor.cropping');
    callback && callback();
  }

  return {

    showBackgroundPopupMenu: function () {
      if (!isEnabled) {
        return;
      }
      showBackgroundPopupMenu($('#svgcontent').find('g.background'));
    },

    dblClick: function (opts) {
      if (!isEnabled) {
        return;
      }

      const elems = canvas.getSelectedElems();
      const $selected = $(elems[0]);

      opts.mouse_target = opts.mouse_target || {};

      if (opts.is_click_inside && opts.mouse_target.id === 'svgroot' && $selected.is(`image#${config.background.image}`)) {
        INKIVE.EditorFacade.handle('background', 'crop');
      }
    },

    cropLayoutContent: function (opts) {
      if (!isEnabled) {
        return;
      }
      const $elem = $(opts.elem);
      const backgroundId = $('svg > g.background image').attr('id');
      const isBackgroundImage = $elem.is('image') && $elem.attr('data-old-id') === backgroundId;

      isBackgroundImage && cropBackgroundContent(opts.layout, $elem[0], opts.hasChanges);
    },

    enableBackground: function () {
      isEnabled = true;
    },

    disableBackground: function () {
      isEnabled = false;
    },

    backgroundReposition: function (opts) {
      $(opts.layout).is('image') && showBackgroundClipper(opts.layout, opts.callback);
    }
  };
};
